export enum URLParams {
  UID = 'uid',
  FORM_UID = 'formUid',
  PRIMARY_ORG_UID = 'primaryEngagement.primaryOrg.uid',
  PRIMARY_ORG_NAME = 'primaryEngagement.primaryOrg.name'
}
